import {
  getCookie,
  setCookie,
  isUserLogin,
  isUserEdit,
  globalGoLogin,
  globalGologinEdit,
} from "@/assets/js/common.js";
import { BuiedPointClick_Fn } from "@/assets/js/BuriedPointEvent.js";

export default {
  name: "userCardSearch",
  data() {
    return {
      switchBabyFlag: false,
      showeditTips: false,
      searchText: "",
      countMessage: "0",
      UserInfo: {}, // 用户信息
      babyInfo: [], // 宝宝信息
      currentBabyInfo: {},
      currentBabyNum: 0, // 当前选中宝宝的胎次
      currentBabyMonth: "",
      babyDays: JSON.parse(localStorage.getItem("babyTimes")) || {},
      loginFlag: true, // 登录状态，默认true,表示未登录
      editFlag: false, // 定制状态，默认false，表示未定制
    };
  },
  watch: {
    babyInfo: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.babyInfo = newVal;
        this.currentBabyNum = localStorage.getItem("babyNums");
        this.currentBabyInfo = this.babyInfo.find(
          (item) => item.num == this.currentBabyNum
        );
        console.log(
          "currentBabyInfo1",
          this.babyInfo,
          this.currentBabyNum,
          this.currentBabyInfo
        );
        this.editFlag = isUserEdit();
      },
    },
  },
  computed: {
    currentBabyName: {
      get() {
        if (this.loginFlag) {
          this.currentBabyMonth = "";
          return "未登录";
        } else if (!this.editFlag) {
          this.currentBabyMonth = "";
          return "未定制";
        } else if (
          this.currentBabyInfo &&
          Object.keys(this.currentBabyInfo).length > 0
        ) {
          if (this.currentBabyInfo.tag_id == 1) {
            this.currentBabyMonth = "";
            return "备孕";
          } else {
            this.currentBabyMonth =
              (this.currentBabyNum == 1 && this.babyDays.firsttime) ||
              (this.currentBabyNum == 2 && this.babyDays.secondtime);
            return (
              (this.currentBabyInfo.tag_id == 2 && "怀孕") ||
              this.currentBabyInfo.nick ||
              "鹤小宝"
            );
          }
        } else {
          this.currentBabyMonth = "";
          return "育儿";
        }
      },
      set(val) {},
    },
    getBabyFlag: {
      get() {
        // 已登录
        if (!this.loginFlag) {
          // 已定制
          if (this.editFlag) {
            this.showeditTips = false;
            this.$emit("changeeditFlagTip", false);
            return this.switchBabyFlag;
          } else {
            if (JSON.parse(sessionStorage.getItem("editFlagTip"))) {
              this.showeditTips =
                JSON.parse(sessionStorage.getItem("editFlagTip")) || true;
              this.$emit("changeeditFlagTip", this.showeditTips);
            }
            return this.showeditTips;
          }
        } else {
          return false;
        }
      },
      set(val) {
        console.log("1112121", val);
      },
    },
  },
  created() {
    this.loginFlag = isUserLogin();
    this.editFlag = isUserEdit();
    this.babyInfo =
      (localStorage.getItem("babyInfo") &&
        JSON.parse(localStorage.getItem("babyInfo"))) ||
      [];
    this.currentBabyNum = localStorage.getItem("babyNums");
    this.currentBabyInfo = this.babyInfo.find(
      (item) => item.num == this.currentBabyNum
    );

    console.log("currentBabyInfo", this.currentBabyInfo);
    if (localStorage.getItem("babyTimes")) {
      this.babyDays = JSON.parse(localStorage.getItem("babyTimes"));
    } else {
      this.getBabyDay();
    }
  },
  mounted() {},
  methods: {
    getCookie,
    setCookie,
    goBack() {
      console.log(this.$route.fullPath);
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/home");
      }
    },
    // 获取宝宝日期
    getBabyDay() {
      let babynumBir1 =
        (this.babyInfo.find((item) => item.num == "1") &&
          this.babyInfo.find((item) => item.num == "1").birth) ||
        "";
      let babynumBir2 =
        (this.babyInfo.find((item) => item.num == "2") &&
          this.babyInfo.find((item) => item.num == "2").birth) ||
        "";
      this.$http.post(
        "/parentingTips/getTimeWithBirth",
        {},
        { first: babynumBir1, second: babynumBir2 },
        (res) => {
          if (res.code == "200") {
            this.babyDays = res.data;
            if (Object.keys(res.data).length > 0) {
              localStorage.setItem("babyTimes", JSON.stringify(this.babyDays));
            }
          }
        }
      );
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      return document.querySelector(".usercard-search");
    },
    closeEditTips() {
      this.switchBabyFlag = false;
      sessionStorage.setItem("editFlagTip", false);
      this.showeditTips = false;
      this.$emit("changeeditFlagTip", false);
    },
    // 点击左上角的育儿
    openBabyList() {
      // 判断登陆状态，如果未登陆loginFlag == true，则跳转到登陆页面
      if (this.loginFlag) {
        this.toLogin();
      } else {
        // 已登陆状态
        // 未定制,跳转到添加宝宝页面，并显示提示信息
        if (!this.editFlag) {
          this.addBaby();
        } else {
          BuiedPointClick_Fn("milkinfo_home_babyinfo_click", {
            baby_state: "有" + this.babyInfo.length + "个宝宝",
          });
          this.switchBabyFlag = !this.switchBabyFlag;
        }
      }
    },
    // 跳转管理宝宝
    glBaby() {
      sensors.track("home_changebaby_click", {
        operation_changebaby: "管理宝宝",
      });
      var that = this;
      setTimeout(function () {
        location.href =
          location.origin +
          "/member/babyManage?num=" +
          that.currentBabyInfo.num +
          "&redirect=" +
          encodeURIComponent(window.location.href);
      }, 200);
    },
    // 跳转登陆页面
    toLogin() {
      BuiedPointClick_Fn("milkinfo_home_babyinfo_click", {
        baby_state: "未登录",
      });
      globalGoLogin();
    },
    toSearch() {
      sensors.track("milkinfo_home_search_click");
      sessionStorage.setItem("searchVal", "powderedMilk");
      this.$router.push({
        path: "/search",
        query: {
          searchIndex: "powderedMilk",
          powderedMilkIndex: "powderedMilk", //如果是奶粉百科走传参
        },
      });
    },
    // 添加宝宝
    addBaby() {
      BuiedPointClick_Fn("milkinfo_home_babyinfo_click", {
        baby_state: "未定制",
      });
      var that = this;
      localStorage.setItem("editModule", "添加宝宝");
      this.$store.commit("changeIncludes", []);
      globalGologinEdit({ from: "powderedMilk" });
    },
    // 切换宝宝
    switchBabyInfo(item) {
      sensors.track("home_changebaby_click", {
        operation_changebaby: "切换宝宝",
      });
      localStorage.setItem("babyNums", item.num);
      localStorage.setItem("babyBir", item.birth);
      this.setCookie("babyNum", item.num, 30);
      this.currentBabyNum = item.num;
      this.currentBabyInfo = item;
      this.$emit("babyChange");
      this.closeBaby();
    },
    // 关闭切换宝宝弹窗
    closeBaby() {
      sensors.track("home_changebaby_click", {
        operation_changebaby: "无操作",
      });
      this.switchBabyFlag = false;
    },
  },
};
